import {MachineImage} from "@/models/machineImage";
import AppUser from "@/models/appUser";
import {MaintenanceListElementEntry} from "@/models/maintenanceListElementEntry";
import { parseMaintenanceList } from '@/utils/maintenanceListUtils';
import {Machine} from "@/models/machine";
import {MachinePdf} from "@/models/machinePdf";

export enum MachineImageType {
  imageMaintenance = "imageMaintenance",
  imageMontageansicht = "imageMontageansicht",
  imageSteuerung = "imageSteuerung",
  imageTypenschild = "imageTypenschild",
  imageBauteileSchrank = "imageBauteileSchrank",
  imageDefekteBauteile = "imageDefekteBauteile"
}

export class Maintenance {

  public id: string;
  public productionNr!: string;
  public flapNr!: string;
  public maintenanceDate!: string; // date
  public comment!: string;
  public appUser!: AppUser;
  public machine!: Machine;

  public createdAt!: string;
  public updatedAt!: string;

  public maintenanceImages: MachineImage[] = [];
  public maintenanceImagesNotRequired!: boolean;
  public imageMaintenanceComment!: string;
  
  public documentPdfs: MachinePdf [] = [];
  public documentTUV?: MachinePdf;
  public hasImages!: boolean;
  public imagesCount!: number;
  public maintenanceList!: MaintenanceListElementEntry[];

  constructor(maintenenaceData: any) {
    this.id = maintenenaceData._id;
    Object.assign(this, maintenenaceData);

    if (maintenenaceData.id) {
      this.id = maintenenaceData.id;
    }

    if (maintenenaceData.appUser) {
      this.appUser = new AppUser(maintenenaceData.appUser);
    }

    if (maintenenaceData.machine) {
      // TODO: Torben, relevant??
      //this.machine = new Machine(maintenenaceData.machine);
    }

    if (maintenenaceData.maintenanceImages) {
      this.maintenanceImages = maintenenaceData.maintenanceImages.map((data: any) => new MachineImage(data, MachineImageType.imageMaintenance));
    }

    if (maintenenaceData.maintenanceList) {
      this.maintenanceList = parseMaintenanceList(maintenenaceData.maintenanceList)
        .map((element: any) => new MaintenanceListElementEntry(element));
    }
  }

}
